export default {
	styleOverrides: {
		root: {
			fontSize: 16,
			lineHeight: "19px",
			fontWeight: "500"
		}
	}
}
